import './accessible.css'

const accessible = () =>{
    return (
        <div>

        <section class="sure-send-accessibility">
                <div class="accessibility-container">
                    <h2 class="">Empowering Individuals & SMEs with Seamless Financial Solutions</h2>
                    <p class="">
                        SureSend bridges financial gaps, offering accessible, secure, and effortless payment solutions for individuals and businesses alike.
                    </p>
            
                    <div class="accessibility-content">
                        <div class="accessibility-item">
                            {/* <div class="accessibility-icon">
                                <img src="" alt="Individuals"/>
                            </div> */}
                            <h3>For Individuals</h3>
                            <p>Instant, secure, and affordable cross-border payments designed for your everyday transactions.</p>
                        </div>
            
                        <div class="accessibility-item">
                           
                            <h3>For SMEs</h3>
                            <p>Empowering businesses with seamless transactions and access to global markets.</p>
                        </div>
                    </div>
                </div>
            </section>
            
        </div>
    )
}

export default accessible